module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [(_vm.hasAdminPermission) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Administration")]) : _vm._e(), _vm._v(" "), (_vm.hasPermission(_vm.$store, 'SETUP')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu icon-fw"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Data Options'
      }
    }
  }, [_c('i', {
    staticClass: "is-icon"
  }, [_vm._v("DO")]), _vm._v("\n          Data Options\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Roles'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-group"
  }), _vm._v("\n          Roles\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Users'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("\n          Users\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - User Groups'
      }
    }
  }, [_c('i', {
    staticClass: "is-icon"
  }, [_vm._v("UG")]), _vm._v("\n          User Groups\n        ")])], 1), _vm._v(" "), (_vm.isSystemOptionParameterEnabled('ENABLE_MULTIPLE_USER_BRANDS')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Tariff Set'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-hand-scissors-o"
  }), _vm._v("\n          Tariff Set\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Documents'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v("\n          Documents\n        ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission(_vm.$store, 'PARTY')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu icon-fw"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Parties'
      }
    }
  }, [_c('i', {
    staticClass: "is-icon"
  }, [_vm._v("PY")]), _vm._v("\n          Parties\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Party Groups'
      }
    }
  }, [_c('i', {
    staticClass: "is-icon"
  }, [_vm._v("PG")]), _vm._v("\n          Party Groups\n        ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission(_vm.$store, 'FINANCE')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu icon-fw"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Calculations'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  }), _vm._v("\n          Calculations\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Currencies'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v("\n          Currencies\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Exchange Rates'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v("\n          Exchange Rates\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Exchange Rate Histories'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-history"
  }), _vm._v("\n          Exchange Rate Histories\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Financial Codes'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v("\n          Financial Codes\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Financial Profiles'
      }
    }
  }, [_c('i', {
    staticClass: "is-icon"
  }, [_vm._v("FP")]), _vm._v("\n          Financial Profiles\n        ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission(_vm.$store, 'ROUTE')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu icon-fw"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Consolidation Points'
      }
    }
  }, [_c('i', {
    staticClass: "is-icon"
  }, [_vm._v("CP")]), _vm._v("\n          Consolidation Points\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Countries'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v("\n          Countries\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Job Types'
      }
    }
  }, [_c('i', {
    staticClass: "is-icon"
  }, [_vm._v("JT")]), _vm._v("\n          Job Types\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Locations'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-location-arrow"
  }), _vm._v("\n          Locations\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Point To Ports'
      }
    }
  }, [_c('i', {
    staticClass: "is-icon"
  }, [_vm._v("PtP")]), _vm._v("\n          Point To Ports\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Port Areas'
      }
    }
  }, [_c('i', {
    staticClass: "is-icon"
  }, [_vm._v("PA")]), _vm._v("\n          Port Areas\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Routing Rules'
      }
    }
  }, [_c('i', {
    staticClass: "is-icon"
  }, [_vm._v("RR")]), _vm._v("\n          Routing Rules\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Spreadsheet Descriptors'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v("\n          Spreadsheet Descriptors\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Transit Miles'
      }
    }
  }, [_c('i', {
    staticClass: "is-icon"
  }, [_vm._v("TM")]), _vm._v("\n          Transit Miles\n        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Vendor Zones'
      }
    }
  }, [_c('i', {
    staticClass: "is-icon"
  }, [_vm._v("VZ")]), _vm._v("\n          Vendor Zones\n        ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission(_vm.$store, 'TARIFF')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu icon-fw"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Tariffs'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plane"
  }), _vm._v(" "), _c('span', [_vm._v("Tariffs")])])], 1), _vm._v(" "), (_vm.isSystemOptionParameterEnabled('ENABLE_ACCESSORIALS')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Accessorials'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-truck"
  }), _vm._v(" "), _c('span', [_vm._v("Accessorials")])])], 1) : _vm._e(), _vm._v(" "), (_vm.isSystemOptionParameterEnabled('ENABLE_QUOTE_TAXES')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Quote Taxes'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-legal"
  }), _vm._v(" "), _c('span', [_vm._v("GST-VAT")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission(_vm.$store, 'RFP')) ? _c('li', {
    staticClass: "treeview"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$router.push({
          name: 'Admin - Request For Proposals'
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-handshake-o"
  }), _vm._v(" "), _c('span', [_vm._v("RFPs")])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'MENU_HOME')))]), _vm._v(" "), _c('li', {
    staticClass: "pageLink"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'MENU_DASHBOARD')))])])], 1), _vm._v(" "), (_vm.hasPermission(_vm.$store, 'REPORT')) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Reports")]) : _vm._e(), _vm._v(" "), (_vm.hasPermission(_vm.$store, 'REPORT')) ? _c('li', {
    staticClass: "pageLink"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Admin - Report search',
        query: ( _obj = {}, _obj[_vm.btoa('search')] = _vm.btoa(JSON.stringify({
            category: 'REPORT'
          })), _obj )
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-area-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Reports")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasPermission(_vm.$store, 'QUOTE')) ? _c('li', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'MENU_QUOTES')))]) : _vm._e(), _vm._v(" "), (_vm.hasPermission(_vm.$store, 'QUOTE')) ? _c('li', {
    staticClass: "pageLink"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Add a new Quote'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v(_vm._s(_vm.getConst(_vm.locale, 'ADD_NEW')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasPermission(_vm.$store, 'QUOTE')) ? _c('li', {
    staticClass: "pageLink"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Quote Batch Upload'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Batch Upload")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasPermission(_vm.$store, 'QUOTE')) ? _c('li', {
    staticClass: "pageLink"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchJobs.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Search")])])]) : _vm._e(), _vm._v(" "), (_vm.hasPermission(_vm.$store, 'TARIFF')) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Tariff Builder")]) : _vm._e(), _vm._v(" "), (_vm.hasPermission(_vm.$store, 'TARIFF')) ? _c('li', {
    staticClass: "pageLink"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'RateAssist'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sliders"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Tariff Builder - Add New")])])], 1) : _vm._e(), _vm._v(" "), (_vm.hasPermission(_vm.$store, 'TARIFF')) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Tariff Merger")]) : _vm._e(), _vm._v(" "), (_vm.hasPermission(_vm.$store, 'TARIFF')) ? _c('li', {
    staticClass: "pageLink"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Merge Tariffs'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Tariff Merger - Add New")])])], 1) : _vm._e()])
  var _obj;
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" "), _c('span', [_vm._v("Setup")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-address-book"
  }), _vm._v(" "), _c('span', [_vm._v("Parties")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" "), _c('span', [_vm._v("Financial")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-road"
  }), _vm._v(" "), _c('span', [_vm._v("Routing")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-ship"
  }), _vm._v(" "), _c('span', [_vm._v("Tariff")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f0a4fff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = 2179
// module chunks = 1